module.exports = __webpack_public_path__ + "static/media/Container.7a5f01d9.png";